<template>
<div class="avatar-wrapper">
    <div class="inner" @click="selectAvatar">
        <el-dropdown>
            <el-avatar class="avatar" icon="el-icon-user-solid" :src="avatarUrl" :size="28"></el-avatar>
            <!-- <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>Logout</el-dropdown-item>
            </el-dropdown-menu> -->
        </el-dropdown>
    </div>
    <el-dialog
        :title="title"
        :visible="visible"
        destroy-on-close
        @cancel="visible=false"
        :before-close="handleClose"
    >
        <div class="form-container">
            <el-upload
                class="avatar-uploader"
                :headers="headers"
                :action="url"
                :http-request="uploadAvatar"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-change="handleChange"
                :before-upload="beforeAvatarUpload"
            >
                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <el-avatar :src="imageUrl" :size="128" />
            <el-avatar :src="imageUrl" :size="64" />
            <el-avatar :src="imageUrl" :size="32" />
        </div>
    </el-dialog>
</div>
</template>
<script>
import {BASE_GLOB_API} from "@/config.js";
import {axiosPut,axiosPost,axiosGet} from "@/api/api";
import EventBus from '@/utils/EventBus';

export default {
    name:'revAvatar',
    props:{
        // avatarUrl:{
        //     type:String
        // }
    },
    data(){
        return {
            title:'修改头像',
            visible:false,
            url:BASE_GLOB_API+'/user/modifyHeadImg',
            info:BASE_GLOB_API+'/user/info',
            imageUrl:'',
            headers:{},
            fileRaw:null,
            api:BASE_GLOB_API,
            avatarUrl:'',
            userInfo:'',
        }
    },
    created(){
        this.platform()
        EventBus.$on('modifyHeadImg', value => {

           if(value){
             this.platform()
           }

        })
    },
    mounted(){
        // this.headers = {
        //     Authorization:"Bearer "+window.sessionStorage.getItem('Token'),
        //     token:"Bearer "+window.sessionStorage.getItem('Token'),
        //     X-Access-Token:"Bearer "+window.sessionStorage.getItem('Token')
        // }
        this.headers['X-Access-Token'] = window.localStorage.getItem('Token')
    },
    methods:{
        selectAvatar(){
            this.$router.push({name:"center"})
        },
        platform(){
            axiosGet(this.info).then(res=>{
               if(res.code ==200){
                   this.userInfo =res.result
                   if(this.userInfo.headImg){
                     this.avatarUrl =this.api + this.userInfo.headImg
                     this.imageUrl = this.api + this.userInfo.headImg
                    }else{
                     this.avatarUrl =''
                    }
               }else{
                    this.$message.error(res.message);
                }
            })
           
        }, 
        handleClose(){
          this.visible =false;
        },
        handleChange(file, fileLists){
            console.log("handleChange:", file, fileLists)
            this.fileRaw = file.raw;
        },
        uploadAvatar(r){
            console.log("uploadAvatar", r)
            let formData = new FormData();
            formData.append("headImgFile", this.fileRaw);
            console.log("formData", formData)
            axiosPost(this.url, formData).then(res=>{
                if(res.code == 200){
                    this.avatarUrl = this.api + res.result
                    this.imageUrl = this.api + res.result
                    // console.log("3", this.avatarUrl)
                }
              
            })
        },
        handleAvatarSuccess(res, file){
            console.log("handle avatar success:", res, file);
            this.imageUrl = URL.createObjectURL(file.raw);
            if(res.success){

            }else{
                this.$message.error(res.message);
            }
            
        },
        beforeAvatarUpload(file){
            const isPic = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
            const isLt2M = file.size / 1024 / 1024 < 2;
            if(!isPic){
                this.$message.error("上传头像只能是图片");
            }
            if(!isLt2M){
                this.$message.error("上传头像图片大小不能超过2MB");
            }
            return isPic && isLt2M;
        },
    }
}
</script>
<style lang="less" scoped>
.form-container {
    display:flex; justify-content: space-between; align-items: center; padding:0 30px;
}
.avatar-wrapper {
    .inner {
        cursor: pointer;
    }
}
.avatar-uploader {
    ::v-deep .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        &:hover {
            border-color: #4458FE;
        }
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>